import { Routes } from '@angular/router';
import { HomeRedirectComponent } from './pages/home-redirect/home-redirect.component';
import { WnLogoutRedirectorComponent } from './pages/wn-logout-redirector/wn-logout-redirector.component';
import { Authorities } from './shared/enums/authorities.enum';
import { Modules } from './shared/enums/modules.enum';
import { canActivateAnyAuthGuard } from './shared/guards/can-activate-any-auth.guard';
import { canActivateDashboardAccessGuard } from './shared/guards/can-activate-dashboard-access.guard';
import { canActivateModuleGuard } from './shared/guards/can-activate-module.guard';

// TO DO: Create global map of ALL routes and use it instead of hardcoded strings
export const APP_ROUTES: Routes = [
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
    canActivate: [canActivateDashboardAccessGuard],
  },
  {
    path: 'resources',
    loadChildren: () => import('./pages/resources/resources.routes').then((m) => m.RESOURCES_ROUTES),
  },
  // {
  //   path: 'analytics',
  //   loadChildren: () => import('./pages/analytics/analytics.routes').then((m) => m.ANALYTICS_ROUTES),
  // },
  {
    path: 'notifications',
    loadComponent: () => import('./pages/notifications/notifications.component').then((m) => m.NotificationsComponent),
    canActivate: [canActivateModuleGuard, canActivateAnyAuthGuard],
    data: {
      modules: [Modules.ALARMS],
      authorities: [Authorities.NOTIFICATIONS_MANAGE_ALARMS, Authorities.NOTIFICATIONS_VIEW_ALARMS],
    },
  },
  {
    path: 'theft-protection-alarm/:id',
    loadComponent: () =>
      import('./pages/theft-protection/theft-protection-landing-page.component').then(
        (m) => m.TheftProtectionLandingPageComponent,
      ),
    canActivate: [canActivateModuleGuard, canActivateAnyAuthGuard],
    data: {
      modules: [Modules.ALARMS, Modules.THEFT_PROTECTION],
    },
  },
  {
    path: 'internal/theft-protection-alarm/:id',
    loadComponent: () =>
      import('./pages/theft-protection/theft-protection-landing-page.component').then(
        (m) => m.TheftProtectionLandingPageComponent,
      ),
    canActivate: [canActivateModuleGuard, canActivateAnyAuthGuard],
    data: {
      modules: [Modules.ALARMS, Modules.THEFT_PROTECTION],
    },
  },
  {
    path: 'user/settings',
    loadComponent: () => import('./pages/user-settings/user-settings.component').then((m) => m.UserSettingsComponent),
  },
  {
    path: 'not-found',
    loadComponent: () => import('./pages/not-found-page/not-found-page.component').then((m) => m.NotFoundPageComponent),
  },
  {
    path: 'maintenance',
    loadChildren: () => import('./pages/maintenance/maintenance.routes').then((m) => m.MAINTENANCE_ROUTES),
  },
  {
    path: 'automated-transfers',
    loadChildren: () => import('./pages/transfers/transfers.routes').then((m) => m.TRANSFERS_ROUTES),
  },
  {
    path: 'reports',
    loadChildren: () => import('./pages/reports/reports.routes').then((m) => m.REPORTS_ROUTES),
  },
  {
    path: 'locations',
    loadChildren: () => import('./pages/locations/locations.routes').then((m) => m.LOCATIONS_ROUTES),
  },
  {
    path: 'administration',
    canActivate: [canActivateAnyAuthGuard],
    data: {
      authorities: [
        Authorities.USER_VIEW,
        Authorities.MAINTENANCE_TYPE_MANAGE,
        Authorities.CUSTOMER_VIEW,
        Authorities.ORGANISATION_VIEW,
        Authorities.NOTIFICATIONS_MANAGE_DEFAULT_RECIPIENTS,
        Authorities.EQUIPMENT_STATUS_MANAGE,
        Authorities.ADDITIONAL_FIELD_VIEW,
        Authorities.ADDITIONAL_FIELD_MANAGE,
        Authorities.MAINTENANCE_TASK_VIEW,
        Authorities.MAINTENANCE_TASK_MANAGE,
      ],
    },
    loadChildren: () => import('./pages/administration/administration.routes').then((m) => m.ADMINISTRATION_ROUTES),
  },
  {
    path: 'wn-logout-redirector',
    component: WnLogoutRedirectorComponent,
  },
  { path: '', component: HomeRedirectComponent, pathMatch: 'full' },
  { path: '**', redirectTo: '/not-found' },
];
